import React from 'react';
import Table from 'shared/migration-components/table';
import {
  OccurrenceProps,
  translatedOccurrenceProps,
  OccurenceTargetEnum,
} from '../types';
import useOrderOccurrences from '../hooks/use-order-occurrences';
import {useNavigate, useParams} from 'react-router-dom';
import styled from 'styled-components';
import Button from 'shared/migration-components/button';
import dateFnsService from 'shared/services/date-fns-service';
import StatusButton from 'shared/components/status-button';
import toBrl from 'shared/util/to-brl';
import {IoTrashBin} from 'react-icons/io5';
import ApiDynamicButton from 'shared/migration-components/api-dynamic-button';
import ordersKeys from '../util/orders-keys';

const Occurrences: React.FC = () => {
  const {id} = useParams();
  const {data = [], isLoading} = useOrderOccurrences(id!);
  const navigate = useNavigate();

  return (
    <Container>
      <Button title="CADASTRAR OCORRÊNCIA" onClick={() => navigate('create')} />
      <Table<OccurrenceProps>
        data={data}
        {...{isLoading}}
        translatedPropsKey={translatedOccurrenceProps}
        options={[
          'description',
          'observation',
          {value: 'value', column: (row) => toBrl(row.value)},
          {
            value: 'payer',
            column: (row) => (
              <StatusButton
                text={
                  row.payer === OccurenceTargetEnum.COMPANY
                    ? 'Empresa'
                    : row.payer === OccurenceTargetEnum.CITY
                    ? 'Cidade'
                    : row.payer === OccurenceTargetEnum.DELIVERY_MAN
                    ? 'Entregador'
                    : 'N/A'
                }
                variant={
                  row.payer === OccurenceTargetEnum.COMPANY
                    ? 'info'
                    : row.payer === OccurenceTargetEnum.CITY
                    ? 'success'
                    : row.payer === OccurenceTargetEnum.DELIVERY_MAN
                    ? 'warn'
                    : 'error'
                }
              />
            ),
          },
          {
            value: 'receiver',
            column: (row) => (
              <StatusButton
                text={
                  row.receiver === OccurenceTargetEnum.COMPANY
                    ? 'Empresa'
                    : row.receiver === OccurenceTargetEnum.CITY
                    ? 'Cidade'
                    : row.receiver === OccurenceTargetEnum.DELIVERY_MAN
                    ? 'Entregador'
                    : 'N/A'
                }
                variant={
                  row.receiver === OccurenceTargetEnum.COMPANY
                    ? 'info'
                    : row.receiver === OccurenceTargetEnum.CITY
                    ? 'success'
                    : row.receiver === OccurenceTargetEnum.DELIVERY_MAN
                    ? 'warn'
                    : 'error'
                }
              />
            ),
          },
          {
            value: 'deliveryMan.name',
            column: (row) => row.deliveryMan?.name ?? 'N/A',
          },
          {
            value: 'createdAt',
            column: (row) => dateFnsService.dateTimeFormat(row.createdAt),
          },
          {
            value: 'id',
            label: 'Ações',
            column: (row) => (
              <ApiDynamicButton
                confirmButtonText="ocorrência"
                keys={{deleteList: ordersKeys.occurrences(id!)}}
                button={{icon: <IoTrashBin />, tooltip: 'Remover ocorrência'}}
                request={{
                  method: 'DELETE',
                  url: `/orders/${id}/occurrences/${row.id}`,
                  errorTitle: 'Erro ao remover ocorrência',
                  successTitle: 'Remover ocorrência',
                  successMessage: 'Ocorrência removida com sucesso',
                }}
              />
            ),
          },
        ]}
      />
    </Container>
  );
};

export default Occurrences;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
